import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Col, Row, Card, CardBody, UncontrolledTooltip } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import moment from "moment"

import TableContainer from "components/Common/TableContainer"
import Breadcrumbs from "components/Common/Breadcrumb"
import MiniCards from "pages/Dashboard/mini-cards"
import { getPartnerRequests } from "store/actions"
import ModalRetailerRequest from "./ModalRetailerRequest"

const RetailerRequest = props => {
  const dispatch = useDispatch()
  const [modal, setModal] = useState(false)
  const [selectedRequest, setSelectedRequest] = useState(null)

  const { partnerRequestsData, loading, total, currentPage, limit } =
    useSelector(state => state.partnerRequests)

  const [filter, setFilter] = useState({
    page: 1,
    limit: 100,
  })

  useEffect(() => {
    dispatch(getPartnerRequests(filter))
  }, [dispatch, filter])

  const toggle = () => {
    setModal(!modal)
  }

  const handleShowClick = request => {
    setSelectedRequest(request)
    toggle()
  }

  const columns = useMemo(
    () => [
      {
        Header: props.t("ID"),
        accessor: "id",
      },
      {
        Header: props.t("Brand Name"),
        accessor: "brandName",
      },
      {
        Header: props.t("User Name"),
        accessor: "userName",
      },
      {
        Header: props.t("Address"),
        accessor: "address",
      },
      {
        Header: props.t("Services"),
        accessor: "services",
        Cell: cellProps => (
          <div style={{ whiteSpace: "pre-wrap", maxWidth: "200px" }}>
            {cellProps.value}
          </div>
        ),
      },
      {
        Header: props.t("Phone"),
        accessor: "phone",
      },
      {
        Header: props.t("Email"),
        accessor: "email",
      },
      {
        Header: props.t("Created At"),
        accessor: "createdAt",
        Cell: cellProps => moment(cellProps.value).format("YYYY-MM-DD HH:mm"),
      },

      {
        Header: props.t("Action"),
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-primary"
                onClick={() => handleShowClick(cellProps.row.original)}
              >
                <i className="mdi mdi-eye font-size-18" id="showtooltip" />
                <UncontrolledTooltip placement="top" target="showtooltip">
                  {props.t("Show")}
                </UncontrolledTooltip>
              </Link>
            </div>
          )
        },
      },
    ],
    [props.t]
  )

  const setPageNumber = page => {
    setFilter(prev => ({ ...prev, page }))
  }

  const handleLimit = limit => {
    setFilter(prev => ({ ...prev, limit }))
  }

  const miniCards = [
    {
      title: props.t("Total Requests"),
      iconClass: "bx-check-circle",
      text: total || 0,
    },
    {
      title: props.t("Today Requests"),
      iconClass: "bx-calendar",
      text:
        partnerRequestsData?.filter(
          item =>
            moment(item.createdAt).format("YYYY-MM-DD") ===
            moment().format("YYYY-MM-DD")
        ).length || 0,
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={props.t("Retailer Requests")}
            breadcrumbItem={props.t("Retailer Requests List")}
          />
          <Row>
            <Col xl="8">
              <Row>
                {miniCards.map((card, key) => (
                  <MiniCards
                    title={card.title}
                    text={card.text}
                    iconClass={card.iconClass}
                    key={"_card_" + key}
                  />
                ))}
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={
                      partnerRequestsData?.sort((a, b) => b.id - a.id) || []
                    }
                    isGlobalFilter={false}
                    isAddOptions={false}
                    customPageSize={filter.limit}
                    setPageNumber={setPageNumber}
                    setLimit={handleLimit}
                    nextPage={null} // Pagination logic handled by reducer/API
                    previousPage={null}
                    currentPage={currentPage}
                    total={total}
                    limit={limit}
                    loading={loading}
                    className="custom-header-css"
                  />
                  <ModalRetailerRequest
                    modal={modal}
                    toggle={toggle}
                    request={selectedRequest}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

RetailerRequest.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(RetailerRequest)
